var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart",
    },
    [
      _vm.searchtype
        ? _c("quicksearch", {
            attrs: {
              searchtype: _vm.searchtype,
              name: "qs",
              placeholder: _vm.$gettext("Personen hinzufügen"),
            },
            on: {
              input: _vm.addContact,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [
            _vm._v(
              _vm._s(
                _vm.$gettext("Kontakte, mit denen der Kalender geteilt wird")
              )
            ),
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Schreibzugriff")))]),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_vm._v(_vm._s(_vm.$gettext("Nicht mehr teilen")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              this.users.length === 0
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: "3",
                        },
                      },
                      [
                        _c(
                          "studip-message-box",
                          {
                            attrs: {
                              type: "info",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$gettext(
                                    "Der Kalender wird mit keinem Kontakt geteilt."
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(this.users, function (user) {
                return _c(
                  "tr",
                  {
                    key: user.id,
                  },
                  [
                    _c("td", [
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          name: _vm.name + "_permissions[]",
                        },
                        domProps: {
                          value: user.id,
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(user.name) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: user.write_permissions,
                            expression: "user.write_permissions",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          name: _vm.name + "_write_permissions[]",
                          "aria-label": _vm.$gettextInterpolate(
                            _vm.$gettext("Schreibzugriff für %{name}"),
                            {
                              name: user.name,
                            },
                            true
                          ),
                        },
                        domProps: {
                          value: user.id,
                          checked: Array.isArray(user.write_permissions)
                            ? _vm._i(user.write_permissions, user.id) > -1
                            : user.write_permissions,
                        },
                        on: {
                          change: function change($event) {
                            var $$a = user.write_permissions,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = user.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    user,
                                    "write_permissions",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    user,
                                    "write_permissions",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(user, "write_permissions", $$c)
                            }
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "actions",
                      },
                      [
                        _c("studip-icon", {
                          attrs: {
                            shape: "trash",
                            "aria-role": "button",
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext(
                                "Kalender nicht mehr mit %{name} teilen"
                              ),
                              {
                                name: user.name,
                              },
                              true
                            ),
                          },
                          on: {
                            click: function click($event) {
                              return _vm.removeContact(user.id)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }